import React, { useState, useEffect } from "react";
import BookCard from "./BookCard";

export default function App() {
  const API_URL = "https://www.googleapis.com/books/v1/volumes?q=";
  const apikey = "AIzaSyCnvyop2-6DAVyLbhigqlgVNgm15HyWCVc";

  const [books, setBooks] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");

  const searchBooks = async (title) => {
    console.log("searchTerm", title);
    if (title === "") {
      window.alert("Please fill the box");
    } else if (title === "undefined") {
      window.alert("Please fill a valid keyword");
    } else {
      const response = await fetch(
        `${API_URL}${title}&key=${apikey}&maxResults=40`
      );
      const data = await response.json();
      console.log("data", data);
      console.log("reponse", data.items);
      setBooks(data.items);
    }
  };

  useEffect(() => {
    searchBooks("Importance of books");
  }, []);

  return (
    <div>
      <div className="title-header-container">
        <div className="title-header">
          <div className="title-header-left">
            <h1>Google Books Library</h1>
          </div>
          <div className="title-header-right">
            <input
              onChange={(e) => {
                setSearchTerm(e.target.value);
              }}
              type="text"
              placeholder="Search for Books..."
              value={searchTerm}
            ></input>
            <i
              class="fa-solid fa-magnifying-glass"
              onClick={() => searchBooks(searchTerm)}
              type="submit"
            ></i>
          </div>
        </div>
      </div>

      <section
        class="books-intro-title-container"
        data-uia="collections-billboard-metadata"
      >
        <div class="books-intro-title">
          <h1>Books</h1>
        </div>
        <div class="books-intro-content">
          <h3>
            Books makes us feel better & keeps our mind fresh and healthy. So
            many titles, so much to experience.
          </h3>
        </div>
      </section>

      <section className="books-collection-row">
        <div className="books-collection-horizontal-row">
          <ul className="books-collection-horizontal-row-item">
            <ul>
              {books.map((book) => (
                <BookCard book={book} />
              ))}
              {/* {books.map((e) => {
                return <div>{e.volumeInfo.title}</div>;
              })} */}
            </ul>
          </ul>
        </div>
      </section>
    </div>
  );
}
